export const AUTH_COOKIE_DOMAIN = process.env.AUTH_COOKIE_DOMAIN || '.bit.team';